<template>
    <v-alert :value="visible" type="success" class="shape cutie">
        <slot />
    </v-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'AlertSuccess',
})
export default class AlertSuccess extends Vue {
    @Prop({ default: true }) visible: boolean;
}
</script>
